import ControlContainer from './controlContainer';
import Tag from './tag';
import { Theme } from '@emotion/react';
import Stack from '@mui/material/Stack';
import { SxProps } from '@mui/system';

export interface IAddTagsProps {
	title: string;
	tags: string[];
	onRemove: (tag: string) => void;
	height?: string;
	stackSx?: SxProps<Theme>;
	disableRemove?: boolean;
	width?: string;
}

const AddTags: React.FunctionComponent<IAddTagsProps> = ({
	title,
	tags,
	onRemove,
	height,
	stackSx,
	disableRemove,
	width
}) => {
	return (
		<ControlContainer header={title} testId="add-tags" height={height} width={width}>
			<Stack
				direction="row"
				padding={[2, 3]}
				gap={1}
				flexWrap="wrap"
				overflow="auto"
				width="100%"
				sx={stackSx}
				data-test-id="add-tags-list"
			>
				{tags.map((t, i) => (
					<Tag testId="add-tags-tag" key={i} tag={t} onClear={!disableRemove ? onRemove : null} />
				))}
			</Stack>
		</ControlContainer>
	);
};

export default AddTags;
